import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./AlertBreakdownStyles";

export default class AlertBreakdown extends Component {
  handleClick(e) {
    document
      .getElementById(`alert${e.target.id}`)
      .scrollIntoView({ block: "start", behavior: "smooth" });
  }
  render() {
    let warning = { count: 0 };
    let emergency = { count: 0 };
    Object.keys(this.props).map((item, i) => {
      if (
        this.props[item].level === "Urgent" &&
        this.props[item].viewings.length === 0
      ) {
        if (emergency.count === 0)
          emergency = { item: this.props[item].id, count: 0 };
        emergency.count += 1;
      } else if (
        this.props[item].level === "Warning" &&
        this.props[item].viewings.length === 0
      ) {
        if (warning.count === 0)
          warning = { item: this.props[item].id, count: 0 };
        warning.count += 1;
      }

      return true;
    });

    return (
      <div className={css(styles.counterWrapper)}>
        {emergency.count > 0 && (
          <a
            id={emergency.item}
            onClick={e => this.handleClick(e)}
            className={css(styles.EmergencyLozenge)}
          >
            <span className={css(styles.EmergencyNumber)}>
              {emergency.count}
            </span>{" "}
            Urgent
          </a>
        )}
        {warning.count > 0 && (
          <a
            id={warning.item}
            onClick={e => this.handleClick(e)}
            className={css(styles.WarningLozenge)}
          >
            <span className={css(styles.WarningNumber)}>{warning.count}</span>{" "}
            Investigate
          </a>
        )}
      </div>
    );
  }
}
